<template>
  <div id="orders-list">
    <div class="list-wrapper">
      <div class="panel-scrollable">
        <v-expansion-panel expand v-model="panel">
          <v-expansion-panel-content v-for="(order, i) in orders" :key="i">
            <template v-slot:header>
              <div
                class="order-header"
                :class="{
                  'order-loaded': order.allLoaded(pallets),
                  'order-not-loaded': !order.allLoaded(pallets)
                }"
              >
                {{ order.toString($t("pallet_orders.no_name")) }}
                <button class="remove-order-button" @click="removeOrder(order)" v-if="user.type != 6">
                  X
                </button>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <div class="select-all-products">
                  <span class="order all-header">Visi</span>
                  <input
                    :id="`select-all-${order.id}`"
                    v-model="order.checked"
                    class="product-selector check"
                    type="checkbox"
                    @input="selectAll(order)"
                  />
                </div>
                <div
                  class="order-product"
                  :class="{
                    'product-loaded': product.withinPallets(pallets),
                    'product-not-loaded': !product.withinPallets(pallets)
                  }"
                  v-for="(product, index) in order.getFilteredProducts()"
                  :key="index"
                  @mouseover="changeSelected(product)"
                  @mouseout="mouseIsOver = -1"
                >
                  <span>{{ product }}</span>
                  <div class="order-product-checkbox">
                                      <input
                    v-model="product.checked"
                    class="product-selector check"
                    type="checkbox"
                    :disabled="product.pallet_id"
                    @input="selectProduct(product)"
                  />
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </div>
    <ConfirmBox ref="confirmBox" @confirmDialog="dialogConfirmed" />
  </div>
</template>

<script>
import ConfirmBox from "@/components/ConfirmBox.vue";
import Helper from "@/models/Helper.js";
export default {
  name: "orders-list",
  props: ["orders", "pallets", "user"],
  data() {
    return {
      //needed for displaying picture on mouseover
      panel: [],
      selectedProduct: null,
      mouseIsOver: -1
    };
  },
  watch: {
    mouseIsOver(val) {
      if (val == -1 && this.selectedProduct != null) {
        this.selectedProduct = null;
        this.$emit("hideProduct");
      }
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await Helper.timeout(1000);
      let open = [];
      this.orders.forEach(order => {
        let checkedCount = 0;
        order.products.forEach(product => {
          if(product.pallet_id == null){
            product.checked = true;
            checkedCount++;
          }
        });
        if(checkedCount == order.products.length){
          order.checked = true;
        }
        open.push(true);
      });
      this.panel = open;
      this.$emit('loaded');
    },

    selectAll(order) {
      this.$emit("selectAll", order);
    },
    selectProduct(product) {
      this.$emit("selectProduct", product);
    },
    /**
     * changes selected product by hovering
     */
    changeSelected(product) {
      product.select(this);
    },

    removeOrder(order) {
      if (order.pal_status === 3) {
        alert(this.$t("orders_list.already_confirmed"));
        return;
      }
      this.$refs.confirmBox.openDialog(
        this.$t("orders_list.confirm_delete"),
        order
      );
    },

    async dialogConfirmed(order) {
      this.$store.commit('setLoading', true);
      await order.unpack();
      this.$store.commit('setLoading', false);
      this.$emit("updated");
    }
  },
  components: {
    ConfirmBox
  }
};
</script>

<style>
.order-header {
  font-weight: 800;
  padding: 3px;
}
.order-loaded {
  background: rgb(152, 209, 160);
}
.order-not-loaded {
  background-color: rgb(239, 247, 89);
}
.order-product {
  position: relative;
  font-weight: 500;
  min-height: 30px;
  width: 100%;
  border: 1px solid black;
}
.product-loaded {
  background: rgb(146, 209, 162);
}
.product-not-loaded {
  background: rgb(239, 247, 89);
}
.product-selector {
  position: absolute;
  top: 0px;
  width: 10px;
  right: 0px;
}
.select-all-products {
  position: relative;
  height: 30px;
  padding-right: 6px;
  text-align: right;
  font-weight: 500;
}
.remove-order-button {
  position: absolute;
  top: 0;
  right: 24px;
  background-color: red;
  width: 20px;
  height: 28px;
  align-content: center;
  padding-top: 1px;
  padding-bottom: 1px;
  border-radius: 2px;
}
.v-expansion-panel__header {
  padding-top: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
  min-height: 0px !important;
}
.order-product-checkbox{
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0;
  right: 20px;
}
.all-header{
  padding-right: 5px;
  font-size: 16px;
}
</style>
